'use strict';

const buttons = document.querySelectorAll('.block.files button');

buttons.forEach(button => button.addEventListener('click', event => {
  const files = button.closest(".files");
  const links = files.querySelectorAll('.show-on-click');

  links.forEach((link) => {
    link.classList.remove('show-on-click');
  });

  button.parentElement.classList.add('d-none');
}));
